export default __webpack_public_path__ + "static/media/1.c79e9dbf.png";